import { booleanAttribute, Component, Input, OnInit } from '@angular/core';
import { ExportData, ExportDataField, ExportDataRow, ExportFormat, sampleJSON } from './export.model';
import { ExportService } from '../../services/common/export.service';
import { IconList } from '../../../iconlist';
import { environment } from '../../../environments/environment';
import { ToasterService } from '../../services/common/toaster.service';
import { ErrorMessages } from '../../../errormessages';


@Component({
  selector: 'export',
  templateUrl: './export.component.html',
  styleUrl: './export.component.css'
})
export class ExportComponent implements OnInit {

  // @Input({ required: true, transform: booleanAttribute }) showUI: boolean = false;
  @Input() showIconOnly: boolean = false;
  exportText: string = 'Export';
  @Input() data: ExportData[] = [];
  @Input() mobileView!:boolean;
  @Input() columns :any;
  protected exportFormatReference = ExportFormat;
  protected selectedExportOption!: ExportFormat;

  isDropdownOpen = false;
  exportIcon = environment.assetsImagePath + IconList.ExportWhiteIcon
  ngOnInit(): void {
  }
  constructor(private exportService: ExportService, private toasterService:ToasterService) {

  }


  protected onExportClick(event: Event, type : any) {
    if (!this.data || this.data?.length === 0) {
      this.toasterService.showInformation(ErrorMessages.minimumExport)
      return;
    }
    const data = this.createData(this.data);
      // Access SCSS variables from CSS custom properties
  const rootStyles = getComputedStyle(document.documentElement);
  const backgroundColor = rootStyles.getPropertyValue('--primaryBackgroundColor').trim();
  const fontColor = rootStyles.getPropertyValue('--secondaryFontColor').trim();
    const headerStyles = {
      backgroundColor: backgroundColor,
      fontColor: fontColor,
      bold: true,
    };
    if(type === ExportFormat.PDF){
      //if number of column is more then 5 then downloaded pdf view will be in landscape else it will be portrait
      const columnCount = this.data.length > 0 ? Object.keys(this.data[0]).length : 0;
      const orientation = columnCount > 5 ? 'landscape' : 'portrait';

      this.exportService.exportToPDF(data, "",headerStyles,orientation);
    }else if(type === ExportFormat.Excel){
      this.exportService.exportToExcel(data, "Colors", "exportedFile",headerStyles);
    }
  }

  protected onSelectionChange(event: Event) {
    this.selectedExportOption = (event.target as HTMLSelectElement).value as ExportFormat;
  }

  private createData(datasourcerr: any[] | null | undefined): ExportDataRow[] {
    const datasource = datasourcerr ?? this.data; // Use data from parameter or fallback
    const exportData: ExportDataRow[] = []; // Correct type for exportData
    if (datasource && datasource.length > 0) {
      const properties = Object.keys(datasource[0]); // Extract headers only once
      for (let i = 0; i < datasource.length; i++) {
        const singleExportDataRow: ExportDataField[] = []; // Initialize as an array of fields
        for (let j = 0; j < properties.length; j++) {
          const singleExportDataField: ExportDataField = {
            fieldName: properties[j], // Use property name as header
            value: datasource[i][properties[j]] // Get the cell value
          };
          singleExportDataRow.push(singleExportDataField); // Push field to the row
        }
        exportData.push(singleExportDataRow); // Add row to exportData
      }
    }
    return exportData;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  exportSelectedType: string = '';

  showExport: boolean = false;
  /**
 *
 * @param type toggle the export button and redirect the open common export-component
 */
toggleExport(type: string) {
  this.mobileView = true;
  this.exportSelectedType = type;
  this.showExport = !this.showExport;
}

selecetdRow(event:any){

}

toggleList(){

}
}
